import "core-js/modules/es.promise.finally.js";
import "../chunk-UFOZ6RGS.mjs";

// src/frontend/helpers/CartVersionMismatchPreventionHelpers.ts
import { useEffect, useState } from "react";
var pendingCartMutations = [];
function isCartMutationPending() {
  return pendingCartMutations.length > 0;
}
var stateChangeSubscriptions = /* @__PURE__ */new Set();
function onStateChange(subscription) {
  stateChangeSubscriptions.add(subscription);
  return () => {
    stateChangeSubscriptions.delete(subscription);
  };
}
function notifyStateChangeSubscriptions() {
  stateChangeSubscriptions.forEach(subscription => {
    subscription({
      isCartMutationPending: isCartMutationPending()
    });
  });
}
function executeNextCartMutation() {
  const nextCartMutation = pendingCartMutations[0];
  nextCartMutation.cartMutation().then(value => {
    nextCartMutation.resolve(value);
  }).catch(reason => {
    nextCartMutation.reject(reason);
  }).finally(() => {
    pendingCartMutations.shift();
    notifyStateChangeSubscriptions();
    if (pendingCartMutations.length) {
      executeNextCartMutation();
    }
  });
  notifyStateChangeSubscriptions();
}
function preventCartVersionMismatch(cartMutation) {
  return new Promise((resolve, reject) => {
    const wrappedCartMutation = {
      resolve,
      reject,
      cartMutation
    };
    pendingCartMutations.push(wrappedCartMutation);
    if (pendingCartMutations.length === 1) {
      executeNextCartMutation();
    }
  });
}
function useCartVersionMismatchPrevention() {
  const [state, setState] = useState({
    isCartMutationPending: isCartMutationPending()
  });
  useEffect(() => {
    const unsubscribe = onStateChange(currentState => {
      setState(currentState);
    });
    return () => {
      unsubscribe();
    };
  }, []);
  return state;
}
export { isCartMutationPending, preventCartVersionMismatch, useCartVersionMismatchPrevention };